import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import {
  create_banner,
  delete_banner,
  fetch_banner_list,
  update_banner,
  upload_banner_image,
} from './api';
import type { BannerPlacement, CreateBannerInput, UpdateBannerInput } from './types';

const LIST_KEY = 'admin-banner-list';

export function use_banner_list(
  placement?: BannerPlacement,
  audience?: 'CUSTOMER' | 'VENDOR',
) {
  return useQuery({
    queryKey: [LIST_KEY, placement ?? 'all', audience ?? 'all'],
    queryFn: () => fetch_banner_list(placement, audience),
    placeholderData: (prev) => prev,
  });
}

export function use_create_banner() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (input: CreateBannerInput) => create_banner(input),
    onSuccess: () => qc.invalidateQueries({ queryKey: [LIST_KEY] }),
  });
}

export function use_update_banner() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ id, input }: { id: string; input: UpdateBannerInput }) => update_banner(id, input),
    onSuccess: () => qc.invalidateQueries({ queryKey: [LIST_KEY] }),
  });
}

export function use_delete_banner() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (id: string) => delete_banner(id),
    onSuccess: () => qc.invalidateQueries({ queryKey: [LIST_KEY] }),
  });
}

export function use_upload_banner_image() {
  return useMutation({ mutationFn: (file: File) => upload_banner_image(file) });
}
